var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231 23.916H89V132.916H231V23.916ZM101 27.916H93V35.916H101V27.916ZM111 27.916H119V35.916H111V27.916ZM137 27.916H129V35.916H137V27.916ZM147 27.916H155V35.916H147V27.916ZM173 27.916H165V35.916H173V27.916ZM183 27.916H191V35.916H183V27.916ZM209 27.916H201V35.916H209V27.916ZM219 27.916H227V35.916H219V27.916ZM93 120.916H101V128.916H93V120.916ZM111 120.916H119V128.916H111V120.916ZM137 120.916H129V128.916H137V120.916ZM147 120.916H155V128.916H147V120.916ZM173 120.916H165V128.916H173V120.916ZM183 120.916H191V128.916H183V120.916ZM209 120.916H201V128.916H209V120.916ZM219 120.916H227V128.916H219V120.916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179 79.416L141 105.916L141 52.916L179 79.416Z",
    fill: "#4C6170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f6f84621e11ffd0a9ab22af0f96b9cdf.svg";
export { ForwardRef as ReactComponent };